document.addEventListener("copy", (event) => {
  const pagelink = `\n\nSkaityti daugiau: ${document.location.href}`;
  event.clipboardData.setData("text/plain", document.getSelection() + pagelink);
  event.preventDefault();
});

Drupal.behaviors.fontsizeChangeBehaviour = {
  attach: function (context, settings) {
    // Your code here, with 'context' to target specific parts of the DOM
    let btn_font_size = once(
      "articleBtnFontSize",
      ".publishing-info-header .publishing-info .btn-ifs-wrapper",
      context
    );
    let article_content_wrapper = once(
      "articleContentWrapper",
      ".straipsnis--full",
      context
    );

    let index = 0;

    btn_font_size.forEach(btn =>{
      btn.addEventListener("click", (e) => {
        index++;
        if (index < 3) {
          console.log(article_content_wrapper);
          
          article_content_wrapper.forEach(item =>{
            item.dataset.fontSizeLevel = index;
          }); 
        } else {
          article_content_wrapper.forEach(item =>{
            index = 0;
            item.dataset.fontSizeLevel = index;
          }); 
        }
      });
    })
  },
};
